import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const storageKey = 'enableUserQuickSwitcher';

const strAtomWithStorage = atomWithStorage(storageKey, '');

// tri-state: undefined means never set, distinct from an explicit false.
const triStateAtom = atom(
  get => {
    const raw = get(strAtomWithStorage);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return undefined;
  },
  (_, set, val: boolean | undefined) => {
    set(strAtomWithStorage, val === undefined ? '' : val ? 'true' : 'false');
  },
);

const useEnableUserQuickSwitcher = () => useAtom(triStateAtom);

export default useEnableUserQuickSwitcher;
